/* eslint-disable no-console */
import Chart from 'react-apexcharts';

export default function ApexGroupLineChart(props) {
  const {lineChartData} = props;
  const xAxis_title = '% Recovery';
  const  yAxis_title = '% Saturation Index';
  const series_data=[];
  function calculateRatio(ipKsp, limit) {
    if (ipKsp.length !== limit.length || ipKsp.length === 0 || limit.length === 0) {
      console.error('IP/KSP and Limit array length should be same and greater than 0');
      return [];
    }

    const ratio = ipKsp.map((value, index) => {
      if (limit[index] !== 0) {
        return ((value * 100) / limit[index])>=140?140:value * 100 / limit[index];
      }
      return 0; // To handle division by zero if any limit value is zero
    });

    return ratio;
  }
  // Iterate over the keys of lineChartData, excluding 'LSI/SDI'
  Object.keys(lineChartData).filter((val) => val !== 'LSI/SDI').forEach((element) => {
    // If the element is 'CaCO3', push its data directly to series_data
    if (element === 'CaCO3') {
      series_data.push({
        'name': element,
        data: lineChartData?.[element],
      });
    } else if (lineChartData?.[element]?.['IP/KSP'].length !== 0) {
      // For other elements, calculate the ratio and push it to series_data
      series_data.push({
        'name': element,
        data: calculateRatio(lineChartData?.[element]?.['IP/KSP'] || [], lineChartData?.[element]?.Limit || []),
      });
    }
  });
  const options = {
    series: series_data,
    chart: {
      height: 220,
      type: 'line',
      dropShadow: {
        enabled: true,
        color: '#000',
        top: 18,
        left: 7,
        blur: 10,
        opacity: 0.2
      },
      parentHeightOffset: 0,
    },
    colors: ['#4d86a5', '#E91E63', '#12e2f1', '#3e517a', '#98da1f', '#fc9f5b', '#21a577', '#c3c4e9', '#9cc76d', '#2dffdf'],
    stroke: {
      curve: 'smooth',
      width: 1.5
    },
    noData: {
      text: 'No Data',
      align: 'center',
      verticalAlign: 'middle',
      offsetX: 0,
      offsetY: 0,
      style: {
        fontSize: '12px',
      }
    },
    grid: {
      borderColor: '#e7e7e7',
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5
      }
    },
    markers: {
      size: 0
    },
    xaxis: {
      type: 'numeric',
      // categories: [lineChartRecoveryData],
      title: {
        text: xAxis_title,
        offsetY: -15,
      },
      min: 0,
      max: 100,
      tickAmount: 9,
      // labels: {
      //   formatter (val) {
      //     return val!==undefined?`${Number(val).toFixed(2)  }`:'0';
      //   },
      // }
    },
    yaxis: {
      title: {
        text: yAxis_title
      },
      min: 0,
      max: 140,
      tickAmount: 7,
      labels: {
        formatter (val) {
          return val!==undefined?`${Number(val).toFixed(0)  }`:'0';
        },
      }
    },
    legend: { position: 'bottom',
      horizontalAlign: 'left',
      floating: true,
      offsetY: 10,
      offsetX: 5
    }
  };
  return (
    <Chart options={options} series={options.series} type="line" width="100%" height='210'/>
  );
}
